export default __webpack_public_path__ + "static/metal-tool-cutting-5a0c0f5a16505791909caf251db6114b.jpg";